import { useCallback } from 'react';

const usePolygonType = () => {
  const isNumber = useCallback(
    (input: any): input is number => typeof input === 'number',
    []
  );

  const isPoint = useCallback(
    (input: any): input is [number, number] => {
      return (
        Array.isArray(input) && input.length === 2 && input.every(isNumber)
      );
    },
    [isNumber]
  );

  const isLineString = useCallback(
    (input: any): input is [number, number][] => {
      return (
        Array.isArray(input) && input.every(coordinates => isPoint(coordinates))
      );
    },
    [isPoint]
  );

  const isPolygon = useCallback(
    (input: any): input is [number, number][][] => {
      return Array.isArray(input) && input.every(ring => isLineString(ring));
    },
    [isLineString]
  );

  const isMultiPolygon = useCallback(
    (input: any): input is [number, number][][][] => {
      return Array.isArray(input) && input.every(polygon => isPolygon(polygon));
    },
    [isPolygon]
  );

  const getPolygonType = (polygon: any) => {
    if (isPoint(polygon)) return 'Point';
    if (isLineString(polygon)) return 'LineString';
    if (isPolygon(polygon)) return 'Polygon';
    if (isMultiPolygon(polygon)) return 'MultiPolygon';
    return 'Unknown';
  };

  return {
    getPolygonType
  };
};

export default usePolygonType;
